import { render, staticRenderFns } from "./GroupEventList.vue?vue&type=template&id=852a7f54&scoped=true&"
import script from "./GroupEventList.vue?vue&type=script&lang=js&"
export * from "./GroupEventList.vue?vue&type=script&lang=js&"
import style0 from "./GroupEventList.vue?vue&type=style&index=0&id=852a7f54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852a7f54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLazy } from 'vuetify/lib/components/VLazy';
installComponents(component, {VLazy})
